export default function isDarkColor(hex: string) {
  const rgb = [
    parseInt(hex[1] + hex[2], 16),
    parseInt(hex[3] + hex[4], 16),
    parseInt(hex[5] + hex[6], 16),
  ];
  const darknessIndex = rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114;
  return darknessIndex <= 186;
}
